import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { BLUR_COMMAND, COMMAND_PRIORITY_HIGH, FOCUS_COMMAND } from 'lexical';
import { useEffect } from 'react';

import { INSERT_SLOT_COMMAND } from '../commands';

type FocusCallbackPluginProps = {
  insertSlotRef?: React.MutableRefObject<((slotName: string) => void) | null>;
  onFocus?: () => void;
  onBlur?: () => void;
};

export const FocusCallbackPlugin = ({
  onFocus,
  onBlur,
  insertSlotRef,
}: FocusCallbackPluginProps): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const removeFocus = editor.registerCommand(
      FOCUS_COMMAND,
      () => {
        onFocus?.();
        if (insertSlotRef) {
          insertSlotRef.current = (slotName: string) => {
            editor.dispatchCommand(INSERT_SLOT_COMMAND, { slotName });
          };
        }
        return false;
      },
      COMMAND_PRIORITY_HIGH,
    );

    const removeBlur = editor.registerCommand(
      BLUR_COMMAND,
      () => {
        if (insertSlotRef) {
          insertSlotRef.current = null;
        }
        onBlur?.();
        return false;
      },
      COMMAND_PRIORITY_HIGH,
    );

    return () => {
      removeFocus();
      removeBlur();
    };
  }, [editor, onFocus, onBlur, insertSlotRef]);

  return null;
};
